/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit, ViewChild,} from '@angular/core';
import {NgOptionTemplateDirective, NgSelectComponent} from '@ng-select/ng-select';
import {BaseComponent, Catalog} from 'compob2b-libs';
import {map, takeUntil} from 'rxjs/operators';
import {CatalogService} from '../../../../../../compob2b-admin/src/app/cabinet/pim/catalog/catalog.service'
import {NbCardModule} from '@nebular/theme'

import {FormsModule} from '@angular/forms'

@Component({
  templateUrl: './catalogs-links-modal.component.html',
  styleUrls: ['./catalogs-links-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NbCardModule,
    NgSelectComponent,
    NgOptionTemplateDirective,
    FormsModule
]
})
export class CatalogsLinksModalComponent extends BaseComponent implements OnInit {

  public catalogId: number;
  public catalogs: Catalog[];

  public insertAdditionalCatalogEvent: EventEmitter<Catalog>;
  public removeAdditionalCatalogEvent: EventEmitter<Catalog>;
  public checkedCatalogs = new Set<number>();
  public selectedCatalogs = [];
  public catalogTree: Catalog[];

  buffer: any[] = [];
  bufferSize = 50;
  numberOfItemsFromEndBeforeFetchingMore = 10;
  catalogService = inject(CatalogService);

  @ViewChild('selectElement') public selectElement: NgSelectComponent;

  ngOnInit(): void {
    this.loading = true;
    this.catalogService
      .getLazyCatalogTree()
      .pipe(
        map(response => response.filter(element => (element.header !== this.translations.root))
        ))
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(catalogTree => {
        catalogTree = catalogTree.map(item => {
          item.disabled = !item.lastLevel;
          return item;
        });
        this.catalogTree = catalogTree;
        this.loading = false;
        this.cdr.detectChanges();
        this.catalogs.forEach(catalog => {
            this.checkedCatalogs.add(catalog.id);
            this.selectedCatalogs.push(catalog.id);
          }
        );
        this.selectedCatalogs = [...this.selectedCatalogs];
        this.selectElement.open();
        this.cdr.detectChanges();
      });

  }

  toggle(isRelation: boolean, catalog: Catalog) {

    if (catalog.lastLevel === false) {
      return false;
    }
    if (isRelation) {
      if (!this.checkedCatalogs.has(catalog.id)) {
        this.checkedCatalogs.add(catalog.id);
        this.insertAdditionalCatalogEvent.emit(catalog);
      }
    } else {
      if (this.checkedCatalogs.has(catalog.id)) {
        this.checkedCatalogs.delete(catalog.id);
        this.removeAdditionalCatalogEvent.emit(catalog);
      }
    }
  }

  public onScrollToEnd() {
    this.fetchMore();
  }

  public onScroll({end}) {
    if (this.loading || this.catalogTree.length <= this.buffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.buffer.length) {
      this.fetchMore();
    }
  }

  private fetchMore() {
    const len = this.buffer.length;
    const more = this.catalogTree.slice(len, this.bufferSize + len);
    this.loading = false;
    this.buffer = this.buffer.concat(more);
  }

}

